module.exports = __webpack_public_path__ + "~@/assets/img/ipconfig_wireless.c84c83f2.png";